import type { ReactNode } from "react";
import { MetricCard, cn, type MetricDelta } from "@fox1ck-org/ui";

export interface MetricTile {
  key: string;
  label: string;
  value: string;
  delta?: MetricDelta;
  /** The line under the value: «CR 5,4%», «≈ 1 300 в пути». */
  note?: ReactNode;
  tone?: "ok" | "danger" | "neutral";
}

/**
 * Numbers in rows of three (доски MToday, MCampaign, MReport): the package's
 * MetricCard in a grid whose hairlines are the gaps. What a desktop strip
 * draws in one row a phone draws in two — the same tiles, the same figures.
 */
export function MetricGrid({ tiles, loading, label, className }: { tiles: MetricTile[]; loading?: boolean; label?: string; className?: string }) {
  return (
    <div role="group" aria-label={label} className={cn("grid shrink-0 grid-cols-3 gap-px overflow-hidden rounded-lg border border-border bg-border", className)}>
      {tiles.map((k) => (
        <MetricCard
          labelCase="none"
          key={k.key}
          label={k.label}
          value={k.value}
          delta={k.delta}
          comparison={k.note}
          tone={k.tone}
          loading={loading}
          className="min-w-0 rounded-none border-0 bg-card px-3 py-2.5"
        />
      ))}
    </div>
  );
}
